module.exports = __webpack_public_path__ + "img/google.8d7f6412.svg";